/**
 * Sortable Preview Item Component
 * 
 * Wraps preview components with sortable functionality
 * 
 * @package TopBuddy
 */

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { __ } from '@wordpress/i18n';
import ComponentSettings from '../../post-settings/components/sortable/ComponentSettings';

const SortablePreviewItem = ({
	id,
	component,
	config,
	isExpanded,
	onToggleSettings,
	onUpdateSettings,
	onRemove,
	children,
}) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({ id });

	const style = {
		transform: CSS.Translate.toString(transform),
		transition,
		opacity: isDragging ? 0.5 : 1,
	};

	const wrapperClassName = `topbuddy-preview-sortable-item ${isDragging ? 'is-dragging' : ''} ${isExpanded ? 'is-expanded' : ''}`;

	const handleRemoveClick = (e) => {
		e.stopPropagation();
		if (onRemove) {
			onRemove();
		}
	};

	// Disable dragging when settings panel is expanded
	const dragListeners = isExpanded ? {} : listeners;
	const dragAttributes = isExpanded ? {} : attributes;

	return (
		<div
			ref={setNodeRef}
			style={style}
			className={wrapperClassName}
			{...dragAttributes}
			{...dragListeners}
		>
			<div 
				className="topbuddy-preview-sortable-item__component"
				onClick={onToggleSettings}
			>
				{children}
			</div>
			{!isDragging && (
				<div className="topbuddy-preview-sortable-item__actions">
					<button
						type="button"
						className="topbuddy-preview-sortable-item__action topbuddy-preview-sortable-item__action--edit"
						onClick={onToggleSettings}
						title={__('Edit component', 'topbuddy')}
					>
						<span className="dashicons dashicons-edit"></span>
					</button>
					<button
						type="button"
						className="topbuddy-preview-sortable-item__action topbuddy-preview-sortable-item__action--delete"
						onClick={handleRemoveClick}
						title={__('Remove component', 'topbuddy')}
					>
						<span className="dashicons dashicons-trash"></span>
					</button>
				</div>
			)}
			{isExpanded && (
				<ComponentSettings
					component={component}
					config={config}
					onUpdateSettings={onUpdateSettings}
					onClose={onToggleSettings}
				/>
			)}
		</div>
	);
};

export default SortablePreviewItem;
